import React from 'react';
import PropTypes from 'prop-types';
import ProfileBanner from '../../../assets/images/ProfileBanner.png';

// All responsive sizing is handled by dashboard.responsive.css
// (.bc-root, .bc-overlay, .bc-avatar, .bc-name, .bc-email)
// No JS breakpoint logic needed here.

const BusinessCard = ({ businessInfo, data }) => (
  <div className="bc-outer">
    {/*
      bc-outer constrains max-width so padding-top:100% on bc-root
      always derives height from the capped width — perfect square at all sizes.
    */}
    <div className="bc-root">
      {/* Banner / cover image */}
      <img
        src={businessInfo?.cover_image || ProfileBanner}
        className="img-fluid"
        style={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          display: 'block',
        }}
        alt="Business banner"
      />

      {/* Bottom overlay */}
      <div className="bc-overlay">
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, minWidth: 0 }}>
          <div className="bc-avatar">
            <img
              src={businessInfo?.logo || ProfileBanner}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                borderRadius: '50%',
              }}
              alt="Business logo"
            />
          </div>
          <div style={{ minWidth: 0 }}>
            <div className="bc-name">{businessInfo?.name  || 'My Business'}</div>
            <div className="bc-email">{businessInfo?.email || ''}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

BusinessCard.propTypes = {
  businessInfo: PropTypes.object,
  data:         PropTypes.object,
};

export default BusinessCard;